var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: _vm.routerLink }}},[_c('div',{class:'nav nav-'+_vm.nav,attrs:{"module":_vm.nav}},[_c('div',{staticClass:"nav-icon"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }